"use client"

import { GetPageByRouteQuery } from "@eurodrive/apollo"
import { BlockRenderer } from "@eurodrive/ui"
import { getBreadCrumbs, transformProperties } from "@eurodrive/utils"

type Props = {
  data: GetPageByRouteQuery
  locale: string
}

const components = {
  heroBannerInnerPages: () => import("@eurodrive/ui/Banner"),
  carSaleBanner: () => import("./CarSaleBanner"),
  textAndImageOnTheSideWidthIconList: () =>
    import("@eurodrive/ui/TextImageBlock"),
  stepsBlock: () => import("./StepsBlock"),
  leasingBanner: () => import("./LeasingBanner"),
}

export default function Service({ data, locale }: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)
  return (
    <>
      {blocks?.blocks?.map((block: any, index: number) => {
        let blockProps = {}
        if (block.blockType === "heroBannerInnerPages") {
          blockProps = { breadCrumbs, greyBreadcrumbs: true, compact: true }
        }

        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            locale={locale}
            props={blockProps}
          />
        )
      })}
    </>
  )
}
